import { z } from 'zod/v4';

import { ApiIntegrationStatusRuntype } from './3rdPartyBackendTypes';

export type BossardCurrencyDTO = z.infer<typeof BossardCurrencyDTORuntype>;
export const BossardCurrencyDTORuntype = z.enum(['EUR', 'USD', 'GBP', 'CHF']);

export interface BossardCredentialsDTO extends z.infer<typeof BossardCredentialsDTORuntype> {}
export const BossardCredentialsDTORuntype = z.object({
    username: z.string(),
    password: z.string(),
    currency: BossardCurrencyDTORuntype,
    price_url: z.string(),
    stock_url: z.string(),
});

export interface BossardCredentialsInputDTO extends z.infer<typeof BossardCredentialsInputDTORuntype> {}
export const BossardCredentialsInputDTORuntype = z.object({
    username: z.string().optional(),
    password: z.string().optional(),
    currency: BossardCurrencyDTORuntype.optional(),
    price_url: z.string().optional(),
    stock_url: z.string().optional(),
});

export interface BossardResponseBodyDTO extends z.infer<typeof BossardResponseBodyDTORuntype> {}
export const BossardResponseBodyDTORuntype = z.object({
    data: BossardCredentialsDTORuntype.nullable(),
    status: ApiIntegrationStatusRuntype,
});
